module.exports = __webpack_public_path__ + "e5.no2.8dd6869f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/e5.no2.jpg
// module id = elTK
// module chunks = 0